import { posLook } from '#max-core'
import { MAX_CONTROLS_KEY, MAX_LOOK_KEY } from '#max-runtime/context.ts'
import MaxPosButton from '~/components/MaxPosButton.vue'
import MaxPosField from '~/components/MaxPosField.vue'
import MaxPosFilterBar from '~/components/MaxPosFilterBar.vue'
import MaxPosDataTable from '~/components/MaxPosDataTable.vue'
import MaxPosCalendar from '~/components/MaxPosCalendar.vue'
import MaxPosBoard from '~/components/MaxPosBoard.vue'
import MaxPosDetail from '~/components/MaxPosDetail.vue'
import MaxPosIcon from '~/components/MaxPosIcon.vue'

// Johku Max specs cannot style themselves inside POS: every report, dashboard and tool renders
// in the POS look, and the preset a spec names only picks compact or normal density.
// Controls listed here are drawn with POS markup instead of the Max renderer's own.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(MAX_LOOK_KEY, posLook)
  nuxtApp.vueApp.provide(MAX_CONTROLS_KEY, {
    button: MaxPosButton,
    field: MaxPosField,
    filterbar: MaxPosFilterBar,
    datatable: MaxPosDataTable,
    calendar: MaxPosCalendar,
    board: MaxPosBoard,
    detail: MaxPosDetail,
    icon: MaxPosIcon
  })
})
